// extracted by mini-css-extract-plugin
export var button = "_f9-4";
export var hasDarkBackground = "_f9-7";
export var hasLightBackground = "_f9-6";
export var iconWrapper = "_f9-0";
export var large = "_f9-2";
export var medium = "_f9-1";
export var small = "_f9-5";
export var xsmall = "_f9-3";